/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventAccess } from './EventAccess';
import {
    EventAccessFromJSON,
    EventAccessFromJSONTyped,
    EventAccessToJSON,
    EventAccessToJSONTyped,
} from './EventAccess';
import type { ScoringMode } from './ScoringMode';
import {
    ScoringModeFromJSON,
    ScoringModeFromJSONTyped,
    ScoringModeToJSON,
    ScoringModeToJSONTyped,
} from './ScoringMode';
import type { JudgingMode } from './JudgingMode';
import {
    JudgingModeFromJSON,
    JudgingModeFromJSONTyped,
    JudgingModeToJSON,
    JudgingModeToJSONTyped,
} from './JudgingMode';
import type { EventParticipation } from './EventParticipation';
import {
    EventParticipationFromJSON,
    EventParticipationFromJSONTyped,
    EventParticipationToJSON,
    EventParticipationToJSONTyped,
} from './EventParticipation';
import type { FeedbackLevel } from './FeedbackLevel';
import {
    FeedbackLevelFromJSON,
    FeedbackLevelFromJSONTyped,
    FeedbackLevelToJSON,
    FeedbackLevelToJSONTyped,
} from './FeedbackLevel';

/**
 * Schema for creating an event.
 * @export
 * @interface EventCreate
 */
export interface EventCreate {
    /**
     * 
     * @type {string}
     * @memberof EventCreate
     */
    competition_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventCreate
     */
    name: string;
    /**
     * 
     * @type {EventParticipation}
     * @memberof EventCreate
     */
    participation?: EventParticipation;
    /**
     * 
     * @type {EventAccess}
     * @memberof EventCreate
     */
    access?: EventAccess;
    /**
     * 
     * @type {Date}
     * @memberof EventCreate
     */
    available_start: Date;
    /**
     * 
     * @type {Date}
     * @memberof EventCreate
     */
    available_end: Date;
    /**
     * 
     * @type {number}
     * @memberof EventCreate
     */
    duration_minutes?: number | null;
    /**
     * 
     * @type {ScoringMode}
     * @memberof EventCreate
     */
    scoring_mode?: ScoringMode;
    /**
     * 
     * @type {number}
     * @memberof EventCreate
     */
    max_team_size?: number;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventCreate
     */
    feedback?: FeedbackLevel;
    /**
     * 
     * @type {FeedbackLevel}
     * @memberof EventCreate
     */
    feedback_after_close?: FeedbackLevel;
    /**
     * 
     * @type {JudgingMode}
     * @memberof EventCreate
     */
    judging_mode?: JudgingMode;
    /**
     * 
     * @type {number}
     * @memberof EventCreate
     */
    judging_radius?: number;
    /**
     * 
     * @type {number}
     * @memberof EventCreate
     */
    judging_tolerance?: number;
}



/**
 * Check if a given object implements the EventCreate interface.
 */
export function instanceOfEventCreate(value: object): value is EventCreate {
    if (!('competition_id' in value) || value['competition_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('available_start' in value) || value['available_start'] === undefined) return false;
    if (!('available_end' in value) || value['available_end'] === undefined) return false;
    return true;
}

export function EventCreateFromJSON(json: any): EventCreate {
    return EventCreateFromJSONTyped(json, false);
}

export function EventCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'competition_id': json['competition_id'],
        'name': json['name'],
        'participation': json['participation'] == null ? undefined : EventParticipationFromJSON(json['participation']),
        'access': json['access'] == null ? undefined : EventAccessFromJSON(json['access']),
        'available_start': (new Date(json['available_start'])),
        'available_end': (new Date(json['available_end'])),
        'duration_minutes': json['duration_minutes'] == null ? undefined : json['duration_minutes'],
        'scoring_mode': json['scoring_mode'] == null ? undefined : ScoringModeFromJSON(json['scoring_mode']),
        'max_team_size': json['max_team_size'] == null ? undefined : json['max_team_size'],
        'feedback': json['feedback'] == null ? undefined : FeedbackLevelFromJSON(json['feedback']),
        'feedback_after_close': json['feedback_after_close'] == null ? undefined : FeedbackLevelFromJSON(json['feedback_after_close']),
        'judging_mode': json['judging_mode'] == null ? undefined : JudgingModeFromJSON(json['judging_mode']),
        'judging_radius': json['judging_radius'] == null ? undefined : json['judging_radius'],
        'judging_tolerance': json['judging_tolerance'] == null ? undefined : json['judging_tolerance'],
    };
}

export function EventCreateToJSON(json: any): EventCreate {
    return EventCreateToJSONTyped(json, false);
}

export function EventCreateToJSONTyped(value?: EventCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'competition_id': value['competition_id'],
        'name': value['name'],
        'participation': EventParticipationToJSON(value['participation']),
        'access': EventAccessToJSON(value['access']),
        'available_start': ((value['available_start']).toISOString()),
        'available_end': ((value['available_end']).toISOString()),
        'duration_minutes': value['duration_minutes'],
        'scoring_mode': ScoringModeToJSON(value['scoring_mode']),
        'max_team_size': value['max_team_size'],
        'feedback': FeedbackLevelToJSON(value['feedback']),
        'feedback_after_close': FeedbackLevelToJSON(value['feedback_after_close']),
        'judging_mode': JudgingModeToJSON(value['judging_mode']),
        'judging_radius': value['judging_radius'],
        'judging_tolerance': value['judging_tolerance'],
    };
}

